import React from "react";
import VariantSelect from "@/components/ProductPackages/VariantSelect";
import scale from "@/public/fallbacks/scale.svg";

const VariantPicker = ({ type, heading, numberOfItems, data, defaultValue }) => {
  const variantsBase = window.post_template?.checkout_v4_products;
  const sizeChartLabel = variantsBase?.tr_checkout_v4_sizeChartLabel;
  const sizeChartLink = variantsBase?.checkout_v4_sizeChartLink;

  const SizeChart = () => {
    return (
      <div className="variants-sizeChart">
        {sizeChartLink && (
          <a className="variants-sizeChart__link" href={sizeChartLink}>
            {sizeChartLabel}
            <img src={scale} className="variants-sizeChart__icon" alt={sizeChartLabel} />
          </a>
        )}
      </div>
    );
  };

  return (
    <section className="variant-container">
      <div className="variant-seperator"></div>
      <div className="variant-container__wrapper">
        <div className="variant-container__title">
          {heading && <h3 className="variant-text--heading">{heading}</h3>}
          {type === "size" && <SizeChart sizeChartLink={sizeChartLink} sizeChartLabel={sizeChartLabel} />}
        </div>
        <div className="variant-container__form">
          {[...Array(Number(numberOfItems))].map(function (object, i) {
            return (
              <VariantSelect
                key={i}
                data={data}
                id={`${type}-${i}`}
                itemKey={i}
                size={numberOfItems}
                type={type}
                defaultValue={defaultValue}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { VariantPicker };
